export default __webpack_public_path__ + "static/phone-call-d35848942c955a6232b3ee092fdecc80.png";